import React, { useEffect, useState } from "react";
import TransactionForm from "../components/TransactionForm";
import { useMenu } from "../Products/MenuContext";
// import ProductList from "./ProductList";
import { PaymentMethodProvider } from "contexts/v1/masterData/PaymentMethodContext";
import { useCategory } from "../context/CategoryContext";
import ProductList from "./ProductListTransaction";
// import { useMenu } from "../POS/Products/MenuContext";
// import ProductList from "../POS/components/ProductList";

const EditTransactionPage = ({ initialData, onSuccess }) => {
  const [cart, setCart] = useState([]);
  const {
    menus: products,
    Pagination,
    filterOptions,
    handleFilterByCategory,
  } = useMenu();
    const { categories } = useCategory();

  useEffect(() => {
    if (initialData) {
      setCart(
        initialData.transaction_items.map((item) => ({
          id: item.menu_id,
          name: item.item_name,
          price: parseFloat(item.price),
          quantity: item.quantity,
          tax_percent: item.tax_percent,
        }))
      );
    }
  }, [initialData]);
  const handleAddToCart = (product) => {
    setCart((prev) => {
      const exists = prev.find((item) => item.id === product.id);
      if (exists) {
        return prev.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        return [...prev, { ...product, quantity: 1 }];
      }
    });
  };

  if (!initialData) return <p>Loading transaksi...</p>;

  //   const handleAddToCart = (product) => {
  //     setCart((prev) => {
  //       const exists = prev.find((item) => item.id === product.id);
  //       if (exists) {
  //         return prev.map((item) =>
  //           item.id === product.id
  //             ? { ...item, quantity: item.quantity + 1 }
  //             : item
  //         );
  //       } else {
  //         return [...prev, { ...product, quantity: 1 }];
  //       }
  //     });
  //   };

  //   if (!initialData) return <p>Loading...</p>;

  return (
    <div className="d-flex">
      <div className="flex-grow-1 p-3" style={{ overflowY: "auto" }}>
        <h4>Edit Transaksi: {initialData.code}</h4>
        <ProductList
          categories={categories}
          menus={products}
          onAddToCart={handleAddToCart}
          filterOptions={filterOptions}
          handleFilterByCategory={handleFilterByCategory}
        />
        {Pagination}
      </div>

      <div style={{ width: "500px", borderLeft: "1px solid #ddd" }}>
        <PaymentMethodProvider>
          <TransactionForm
            mode="edit"
            initialData={initialData}
            cartItems={cart}
            setCart={setCart}
            onSuccess={onSuccess}
          />
        </PaymentMethodProvider>
      </div>
    </div>
  );
};

export default EditTransactionPage;
